import type { AssetProcessingActivityPurposeApplication, AssetProcessingCountryRow } from 'config/api/assetRopa/assetRopa.types';

export type AssetProcessingApaFormValues = {
  securityMeasureCategories: string[];
  securityComment: string;
  minimumSecurityAssessment: string;
  minimumSecurityAssessmentComment: string;
  dpiaIndicationStatus: string;
  dpiaIndicationComment: string;
  purposeApplications: AssetProcessingActivityPurposeApplication[];
  countryRows: AssetProcessingCountryRow[];
};

export type AssetProcessingApaDisplayData = AssetProcessingApaFormValues & {
  name: string;
  reviewStatus?: string;
};

export const SECURITY_MEASURE_CATEGORY_OPTIONS = [
  'access_control',
  'encryption_in_transit',
  'encryption_at_rest',
  'logging_monitoring',
  'backup_recovery',
  'incident_response',
] as const;

export const MINIMUM_SECURITY_ASSESSMENT_OPTIONS = ['not_assessed', 'meets', 'partially_meets', 'does_not_meet'] as const;

export const DPIA_INDICATION_STATUS_OPTIONS = ['not_indicated', 'indicated'] as const;

export const APPLICABILITY_STATUS_OPTIONS = ['not_assessed', 'applies', 'does_not_apply'] as const;

export const COUNTRY_VOLUME_OPTIONS = ['low', 'medium', 'high', 'unknown'] as const;
